<template>
  <div class="section">
    <div class="title" :class="{ divisionLabel: isDivisionLabel }" v-on:click="toggle">
      <slot name="title"></slot>
      <span class="toggleIcon" id="toggleIcon">{{ toggleIcon }}</span>
    </div>
    <div class="body" :class="{ tableBoxBody: isTable }" v-if="showSection">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return { 
      showSection: this.defaultOpen, 
      toggleIcon: this.defaultOpen ? "⌃" : "⌄", 
      isTable: this.isTableProp,
      isDivisionLabel: this.isDivisionProp,
    };
  },
  props: {
    isTableProp: { type:Boolean, default: false },
    isDivisionProp: { type:Boolean, default: false },
    defaultOpen: { type: Boolean, default: false } // Control the initial state
  },
  methods: {
    toggle() {
      this.showSection = !this.showSection;
      this.toggleIcon === "⌄"
        ? (this.toggleIcon = "⌃")
        : (this.toggleIcon = "⌄");
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 10.5px;
  margin-right: 5px;
}

.toggleIcon {
  float: right;
  background: none;
  font-size: 12px;
  cursor: pointer;
}

.tableBoxBody {
  right: 70px;
  z-index: 999;
  width: 800px;
  position: absolute;
}

.divisionLabel {
  font-size: 1.17em;
  margin: 1em 6em 1em 0em;
  font-weight: bold;
  border-bottom: solid 1px;
}

#toggle {
  display: block;
}
</style>